module.exports = __webpack_public_path__ + "img/ice-climber.29d33443.png";